<template>
  <sui-page>
    <!-- Page Header -->
    <sui-page-header title="[Samples] OrderSelect" />
    <!-- Page Contents -->
    <sui-page-contents>
      <!-- 차수 이동 Select Box [S] -->
      <div slot="top">
        <cmp-order-select
          v-model="selectedItem"
          :option-list="orderOptionList"
          is-simple
          @list-click="onClickItem"
        />
      </div>
      <button @click="onChangeOptions" style="width: 100px; height: 30px; border: 1px solid blue">change options</button>
      <button @click="onSelectOption" style="width: 100px; height: 30px; border: 1px solid blue">select option</button>
      <!-- 차수 이동 Select Box [E] -->
    </sui-page-contents>
  </sui-page>
</template>

<script>
export default {
  name: 'PGE_FLY_00009', // eslint-disable-line vue/name-property-casing
  data() {
    return {
      // 차수 이동 Select Box [S]
      orderOptionList: [
        {
          key: 'A001',
          order: '1차',
          startDate: '2019-03-01',
          endDate: '2019-06-05',
          label: '결재중',
          status: 'P',
        },
        {
          key: 'A002',
          order: '2차',
          startDate: '2019-03-01',
          endDate: '2019-06-05',
          label: '미진행',
          status: 'N',
        },
        {
          key: 'A003',
          order: '3차',
          startDate: '2019-03-01',
          endDate: '2019-06-05',
          label: '재요청',
          status: 'R',
        },
        {
          key: 'A004',
          order: '3차',
          startDate: '2019-03-01',
          endDate: '2019-06-05',
          label: '완료',
          status: 'F',
        },
        {
          key: 'A005',
          order: '3차',
          startDate: '2019-03-01',
          endDate: '2019-06-05',
          label: '현재버젼',
          status: 'F',
        },
        {
          key: 'A006',
          order: '3차',
          startDate: '2019-03-01',
          endDate: '2019-06-05',
          label: '작성중',
          status: 'P',
        },  
        {
          key: 'A007',
          order: '3차',
          startDate: '2019-03-01',
          endDate: '2019-06-05',
          label: '지연',
          status: 'D',
        },           
      ],

      // 차수 이동 Select Box [E]

      selectedItem: {
        key: '',
        label: '',
      },
    };
  },
  computed: {},
  watch: {},
  datasets: [],
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    onClickItem(item) {
      console.log('[Samples] OrderSelect.onClickItem() was called. (item)', JSON.stringify(item));
      console.log('[Samples] OrderSelect.onClickItem() was called. (v-model)', JSON.stringify(this.selectedItem));
    },
    onChangeOptions() {
      const newOptions = [];
      for (let i = 0; i < 5; i++) {
        newOptions.push({
          key:  `KEY${i}`,
          order: `${i}차`,
          startDate: '2019-11-01',
          endDate: '2019-11-01',
          status: 'F',
        })
        this.orderOptionList = newOptions;
        this.selectedItem = this.orderOptionList[4];
      }
    },
    onSelectOption() {
      this.selectedItem = this.orderOptionList[0];
    },
  },
};
</script>

<style scoped>
</style>
